
export const pulseButtonConfig = {
  id: "pulse",
  label: "Pulse",
  icon: "radar",
  tooltip: "Your strategy, right now",
};

export const calendarButtonConfig = {
  id: "calendar",
  label: "Calendar",
  icon: "calendar_today",
  tooltip: "View calendar timeline",
};

export const strategyButtonConfig = {
  id: "strategy",
  label: "Strategy",
  icon: "lightbulb",
  tooltip: "View design strategy and vision",
};

export const stepByStepButtonConfig = {
  id: "stepByStep",
  label: "Step-by-Step",
  icon: "list",
  tooltip: "Detailed program breakdown",
};

export const slickButtonConfig = {
  id: "slick",
  label: "Overview",
  icon: "dashboard",
  tooltip: "High-level program overview",
};

export const navigationButtons = [
  { viewKey: "pulse", config: pulseButtonConfig },
  { viewKey: "strategy", config: strategyButtonConfig },
  { viewKey: "slick", config: slickButtonConfig },
  { viewKey: "stepByStep", config: stepByStepButtonConfig },
  { viewKey: "calendar", config: calendarButtonConfig },
];
